import { Menu } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { useUiStore } from '@/stores/ui.store';
import { env } from '@/utils/env';
import { UserMenu } from './UserMenu';

export function Header() {
  const user = useAuthStore((s) => s.user);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);

  return (
    <header className="sticky top-0 z-20 flex min-h-14 items-center gap-3 bg-brand px-4 py-1.5 text-white">
      <button
        type="button"
        onClick={toggleSidebar}
        aria-label="Open menu"
        className="rounded-md p-1 hover:bg-white/10 lg:hidden"
      >
        <Menu className="size-6" />
      </button>
      <h2 className="min-w-0 flex-1 truncate text-base sm:text-lg">
        Welcome to {user?.clientName ?? env.appName}
      </h2>
      {user && <UserMenu user={user} />}
    </header>
  );
}
